/* eslint-disable */
const sortSelect = () => {
  document.querySelectorAll('[data-sort-select]').forEach((wrapper, wrapperIndex) => {
    const btn = wrapper.querySelector('.sort-select-btn');
    const list = wrapper.querySelector('.sort-select-list');
    const options = Array.from(wrapper.querySelectorAll('[role="option"]'));

    if (!btn || !list || !options.length) return;

    // Assign stable IDs so aria-activedescendant can reference them
    options.forEach((opt, i) => {
      opt.id = `sort-option-${wrapperIndex}-${i}`;
    });

    let focusedIndex = options.findIndex(o => o.classList.contains('is-selected'));
    if (focusedIndex < 0) focusedIndex = 0;

    const isOpen = () => btn.getAttribute('aria-expanded') === 'true';

    const moveFocus = (index) => {
      focusedIndex = Math.max(0, Math.min(index, options.length - 1));
      options.forEach((o, i) => o.classList.toggle('is-focused', i === focusedIndex));
      btn.setAttribute('aria-activedescendant', options[focusedIndex].id);
      options[focusedIndex].scrollIntoView({ block: 'nearest' });
    };

    const open = () => {
      btn.setAttribute('aria-expanded', 'true');
      list.classList.add('is-open');
      moveFocus(focusedIndex);
    };

    const close = () => {
      btn.setAttribute('aria-expanded', 'false');
      list.classList.remove('is-open');
      options.forEach(o => o.classList.remove('is-focused'));
      btn.removeAttribute('aria-activedescendant');
    };

    const selectOption = (option) => {
      const href = option.dataset.href;

      if (href) window.location.href = href;
    };

    btn.addEventListener('click', () => {
      isOpen() ? close() : open();
    });

    btn.addEventListener('keydown', (e) => {
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          isOpen() ? moveFocus(focusedIndex + 1) : open();
          break;
        case 'ArrowUp':
          e.preventDefault();
          isOpen() ? moveFocus(focusedIndex - 1) : open();
          break;
        case 'Home':
          e.preventDefault();
          if (isOpen()) moveFocus(0);
          break;
        case 'End':
          e.preventDefault();
          if (isOpen()) moveFocus(options.length - 1);
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (isOpen()) selectOption(options[focusedIndex]);
          else open();
          break;
        case 'Escape':
        case 'Tab':
          if (isOpen()) close();
          break;
      }
    });

    options.forEach((option, i) => {
      option.addEventListener('click', () => selectOption(option));
      option.addEventListener('mouseenter', () => moveFocus(i));
    });

    // Keep focus on button when clicking list options
    list.addEventListener('mousedown', (e) => e.preventDefault());

    document.addEventListener('click', (e) => {
      if (isOpen() && !wrapper.contains(e.target)) close();
    });
  });
};

export default sortSelect;
/* eslint-enable */
